import { useTranslation } from "react-i18next";
import { TrendingUp } from "lucide-react";
import { TrendChart } from "./TrendChart";
import { IMC_CLASSES, changeColor } from "@/lib/tracking";

export const ImcResult = ({ result }) => {
  const { t } = useTranslation();
  return <div className="bg-card border border-primary/30 rounded-xl p-5 text-center space-y-4" data-testid="imc-result">
    <p className="text-muted-foreground text-sm">{t("imc.yourImc")}</p>
    <p className="text-5xl font-bold text-primary my-2" data-testid="imc-result-value">{result.imc}</p>
    <p className={`font-semibold ${result.classification.color}`} data-testid="imc-result-classification">{t(`imc.classifications.${result.classification.key}`)}</p>
    <p className="text-xs text-muted-foreground">{t("imc.weight")}: {result.weight} kg · {t("imc.height")}: {result.height} cm</p>
  </div>;
};

export const ImcEvolution = ({ history, chartData }) => {
  const { t } = useTranslation();
  const first = history[history.length - 1];
  const last = history[0];
  return <div className="bg-card border border-border rounded-xl p-5 space-y-5">
    <h2 className="font-semibold flex items-center gap-2"><TrendingUp className="w-4 h-4 text-primary" />{t("imc.evolutionTitle")}</h2>
    <div><p className="text-xs text-muted-foreground mb-2 uppercase">{t("imc.weightLabel")}</p><TrendChart data={chartData} height={180} testId="imc-weight-chart" /></div>
    <div><p className="text-xs text-muted-foreground mb-2 uppercase">{t("imc.imcLabel")}</p><TrendChart data={chartData} metric="imc" height={180} testId="imc-value-chart" />
      <div className="flex flex-wrap gap-3 mt-2 text-xs text-muted-foreground">
        <span>18,5 {t("imc.legend.underweight")}</span><span>25 {t("imc.legend.normal")}</span><span>30 {t("imc.legend.overweight")}</span>
      </div>
    </div>
    {history.length >= 2 && <div className="grid grid-cols-2 gap-3 pt-2 border-t border-border">
      {[["weightChange", last.weight - first.weight, " kg"], ["imcChange", last.imc - first.imc, ""]].map(([key, diff, unit]) =>
        <div key={key} className="bg-secondary/50 rounded-lg p-3 text-center" data-testid={`imc-${key}`}><p className="text-xs text-muted-foreground mb-1">{t(`imc.${key}`)}</p><p className={`text-xl font-bold ${changeColor(diff)}`}>{diff > 0 ? "+" : ""}{diff.toFixed(1)}{unit}</p></div>)}
    </div>}
  </div>;
};

export const ImcReference = () => {
  const { t } = useTranslation();
  return <div className="bg-card border border-border rounded-xl p-5" data-testid="imc-reference">
    <h2 className="font-semibold mb-3">{t("imc.referenceTable")}</h2>
    <div className="space-y-2 text-sm">{IMC_CLASSES.map((item) => <div key={item.key} className="flex justify-between items-center gap-3 py-1 border-b border-border/50 last:border-0"><span className="text-muted-foreground">{item.range}</span><span className={`px-2 py-0.5 rounded-full text-xs font-medium ${item.color}`}>{t(`imc.classifications.${item.key}`)}</span></div>)}</div>
  </div>;
};